export const scanGif = 'https://doris-media-production.s3.sa-east-1.amazonaws.com/mix-static-assets/scan.gif'
